import React from 'react';
import NavigationItem from '../NavigationItem/NavigationItem';
import { Nav, NavLink } from 'reactstrap';
import { NavLink as RRNavLink } from 'react-router-dom';
import { MenuItemPlaceholder } from '@core/ui';
import Cookies from 'js-cookie';
import { IconExternalLink } from '@tabler/icons-react';
import { useFooterConfig } from '../../../stores/index.js';
import CustomStyledText from '../../CustomStyledText/CustomStyledText.jsx';

const FooterMenu = (props) => {
    const { footerElementsStyle } = useFooterConfig();

    const onClickHandler = (event) => {
        event.preventDefault();
        Cookies.set(props.consentCookieName || 'bigfoot_cookie-consent', false, { expires: 180 });
        window.location.reload(false);
    };

    let secondaryNavigation = (
        <React.Fragment>
            <li style={{ width: '140px', padding: '8px' }}>
                <MenuItemPlaceholder />
            </li>
            <li style={{ width: '140px', padding: '8px' }}>
                <MenuItemPlaceholder />
            </li>
            <li style={{ width: '140px', padding: '8px' }}>
                <MenuItemPlaceholder />
            </li>
            <li style={{ width: '140px', padding: '8px' }}>
                <MenuItemPlaceholder />
            </li>
        </React.Fragment>
    );

    if (props.secondaryNavigation) {
        secondaryNavigation = props.secondaryNavigation.map((menuItem, index) => {
            return (
                <NavigationItem key={index} type="footer">
                    {/https?:\/\/.*/.test(menuItem.linkTarget) ? (
                        <CustomStyledText
                            tag="a"
                            styleConfig={footerElementsStyle}
                            className={`anl_footer--menu-lnk-${index + 1} nav-link`}
                            href={menuItem.linkTarget}
                        >
                            {menuItem.text} <IconExternalLink size={18} className="ms-1" />
                        </CustomStyledText>
                    ) : (
                        <CustomStyledText
                            tag={NavLink}
                            innerTag={RRNavLink}
                            styleConfig={footerElementsStyle}
                            className={`anl_footer--menu-lnk-${index + 1}`}
                            to={menuItem.linkTarget === '/' ? '/' : menuItem.linkTarget + '/'}
                            exact
                        >
                            {menuItem.text}
                        </CustomStyledText>
                    )}
                </NavigationItem>
            );
        });
    }

    return (
        <nav aria-label="Footer Navigation">
            <Nav className="ms-auto flex-column flex-lg-row justify-content-end">
                {secondaryNavigation}
                <NavigationItem type="footer">
                    <CustomStyledText
                        tag={NavLink}
                        styleConfig={footerElementsStyle}
                        className="anl_footer--menu-lnk--privacy-policy"
                        onClick={onClickHandler}
                        href="#"
                    >
                        Datenschutzpräferenzen
                    </CustomStyledText>
                </NavigationItem>
            </Nav>
        </nav>
    );
};

export default FooterMenu;
